import { logger } from './logger'
import { buildContinuePath } from './redirects'
import { withoutTrailingSlash } from './utils'
import type { DashboardAuthSuccessResponse } from './auth'

type SupabaseLike = {
  auth: {
    signOut: () => Promise<unknown>
  }
}

export const safeSupabaseSignOut = async (supabase: SupabaseLike): Promise<void> => {
  try {
    await supabase.auth.signOut()
  } catch (error) {
    logger.error('[Auth] No pudimos cerrar la sesión de Supabase tras un intercambio fallido', {
      error,
    })
  }
}

export const redirectToStripeIfNeeded = (
  exchangeResult: DashboardAuthSuccessResponse,
  options: { enabled?: boolean } = {}
): boolean => {
  const enabled = options.enabled ?? true
  if (!enabled) return false

  const stripeInfo = exchangeResult.organization?.integrations?.stripe
  const checkoutUrl = stripeInfo?.checkoutUrl
  if (checkoutUrl) {
    window.location.assign(checkoutUrl)
    return true
  }

  if (stripeInfo?.portalUrl) {
    window.location.assign(stripeInfo.portalUrl)
    return true
  }

  return false
}

export const redirectToDashboard = (
  navigate: (path: string) => void,
  nextParam?: string | null
) => {
  const path = buildContinuePath(nextParam)
  const baseUrl = withoutTrailingSlash(process.env.NEXT_PUBLIC_APP_BASE_URL)

  if (baseUrl) {
    window.location.assign(`${baseUrl}${path}`)
  } else {
    navigate(path)
  }
}
